import React from 'react';

import Details from '../../components/Details/Details';

const DetailsPage = () => (
  <section>
    <Details />
  </section>
);

export default DetailsPage;
